import type React from 'react';
import { useEffect } from 'react';
import { api, apiStatic } from 'AurionCR/components';
import type { InternalAxiosRequestConfig } from 'axios';
import axios from 'axios';
import { normalizeDataBeforeSave } from 'utils';

const instances = [apiStatic, api, axios];
const prepareConfig = (conf: InternalAxiosRequestConfig) => {
  if (conf.method === 'post' && conf.data && typeof conf.data === 'object') {
    conf.data = normalizeDataBeforeSave(conf.data);
  }
  return conf;
};

export const AxiosInterceptorPost: React.FC = ({ children }) => {
  useEffect(() => {
    const results = instances.map((instance) => {
      const id = instance.interceptors.request.use(prepareConfig);
      return { id, instance };
    });

    return () => {
      results.forEach(({ id, instance }) => {
        instance.interceptors.request.eject(id);
      });
    };
  }, []);

  return <>{children}</>;
};
